import { fontStyle, colors } from "Constants";

export const styles = {
  cardStyles: {
    container: {
      height: "80px",
      margin: "16px 32px 0",
    },
    title: {
      fontSize: "18px",
      lineHeight: "25px",
      ...fontStyle.bold,
      marginBottom: "4px",
      color: colors.neutral200,
    },
    cardLabel: {
      padding: 0,
      marginLeft: "16px",
      border: "unset",
      borderRadius: "unset",
    },
    cardActions: {
      width: "max-content",
      marginRight: "16px",
    },
    cardIcon: {
      height: "78px",
      borderRadius: "8px 0 0 8px",
    },
    standards: {
      fontSize: "14px",
      lineHeight: "19px",
      ...fontStyle.medium,
      color: colors.neutral400,
    },
    iconStyle: {
      width: 80,
      height: 80,
    },
  },
  cardStylesV2: {
    container: {
      height: "80px",
      margin: "16px 32px 0",
    },
    iconStyle: {
      width: 80,
      height: 80,
      fill: colors.pink900,
    },
    title: {
      fontSize: "1.6rem",
      lineHeight: "2.4rem",
      fontWeight: 600,
      marginBottom: "4px",
      color: colors.neutral200,
    },
    standards: {
      fontSize: "1.2rem",
      lineHeight: "1.6rem",
      color: colors.neutral400,
      fontWeight: 600,
    },
    cardLabel: {
      paddingLeft: "16px",
      border: "unset",
      borderRadius: "unset",
    },
    cardIcon: {
      height: "78px",
      borderRadius: "8px 0 0 8px",
      backgroundColor: colors.pink900,
    },
  },
  arrowWithCountStyle: {
    backgroundColor: colors.black,
  },
};
